import { CASHOUT } from "./types";
import { TRANSFERS } from "./types"


const verifyBank = data => ({
  type: CASHOUT.VERIFY_BANK,
  payload: data
})

const verifyBankSuccess = data => ({
  type: CASHOUT.VERIFY_BANK_SUCCESS,
  payload: data
})

const cashoutWallet = (data, history) => ({
  type:   CASHOUT.CASHOUT_WALLET,
  payload: data,
  history
});

const cashoutBank = (data, history) => ({
  type: CASHOUT.CASHOUT_BANK,
  payload: data,
  history
})

const fetchBank = data => ({
  type: CASHOUT.FETCH_BANK,
  payload: data,
})

const fetchAllBanks = () => ({
  type: CASHOUT.FETCH_ALL_BANKS
})

const fetchAllBanksSuccess = data => ({
  type: CASHOUT.FETCH_ALL_BANKS_SUCCESS,
  payload: data
})

const fetchBankSuccess = data => ({
  type: CASHOUT.FETCH_BANK_SUCCESS,
  payload: data
})

const cashoutBankSuccess = (data) => ({
    type: CASHOUT.CASHOUT_BANK_SUCCESS,
    payload: data
})

const cashoutWalletSuccess = (data) => ({
  type:   TRANSFERS.BANK_SUCCESS,
  payload: data,
});

const bankTransferFail = (data) => ({
  type:   TRANSFERS.BANK_FAIL,
  payload: data,
});

const agentTransfer = (data) => ({
  type:   TRANSFERS.AGENT,
  payload: data,
});

const agentTransferSuccess = (data) => ({
  type:   TRANSFERS.AGENT_SUCCESS,
  payload: data,
});

const agentTransferFail = (data) => ({
  type:   TRANSFERS.AGENT_FAIL,
  payload: data,
});

const addBank = (data, history) => ({
  type: CASHOUT.ADD_BANK,
  payload: data,
  history
})



export {
  agentTransfer,
  agentTransferSuccess,
  agentTransferFail,
  cashoutWallet,
  cashoutBank,
  cashoutWalletSuccess,
  bankTransferFail,
  cashoutBankSuccess,
  fetchBank,
  fetchBankSuccess,
  addBank,
  fetchAllBanks,
  fetchAllBanksSuccess,
  verifyBank,
  verifyBankSuccess
};
